import { TabV2Item } from 'common/ui/TabsV2';

export type BaseTabConfig<T extends string> = {
  [K in T]: {
    label: K;
    value: K;
    count?: number;
  };
};

export type TabComponents<T extends string> = {
  [K in T]: React.ReactElement;
};

export type GetTabsProps<T extends string> = Partial<{
  [K in T as `${Lowercase<K>}Count`]: number;
}>;

export const createTabSystem = <T extends readonly string[]>(tabNames: T) => {
  type TabType = T[number];

  return {
    createTabs: (props: Partial<GetTabsProps<TabType>>): TabV2Item[] => {
      return tabNames.map((tab) => {
        const countKey =
          `${tab.toLocaleLowerCase()}Count` as keyof typeof props;
        const countValue = props[countKey];
        const hasCount = tab !== 'Profile' && typeof countValue === 'number';

        return {
          label: tab,
          value: tab,
          ...(hasCount && { count: countValue as number })
        };
      });
    }
  };
};
